// import React from "react";

// const Databanner = () => {
//   const bannerStyles = {
//     marginTop:"60px",
//     width: "100%",
//     height: "90vh", 
//     backgroundImage: "url('/image/data-analysis-skill.jpeg')",  
//     backgroundSize: "cover",
//     backgroundPosition: "center center",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     color: "white",
//     position: "relative",
//     overflow: "hidden",
//   };

//   const contentStyles = {
//     maxWidth: "90%",
//     padding: "0 20px",  
//   };

//   const headingStyles = {
//     fontSize: "4rem",  
//     margin: 0,
//     lineHeight: 1.2,
//     fontWeight: "bold",
//   };

//   const paragraphStyles = {
//     fontSize: "1.5rem",  
//     marginTop: "1rem",
//   };

  
//   const mediaQueryStyles = {
//     "@media (max-width: 1200px)": {
//       heading: { fontSize: "3.5rem" },
//       paragraph: { fontSize: "1.3rem" },
//     },
//     "@media (max-width: 768px)": {
//       heading: { fontSize: "2.5rem" },
//       paragraph: { fontSize: "1.2rem" },
//     },
//     "@media (max-width: 480px)": {
//       heading: { fontSize: "2rem" },
//       paragraph: { fontSize: "1rem" },
//     },
//   };

//   return (
//     <div style={bannerStyles}>
//       <div style={contentStyles}>
       
        
//       </div>
//     </div>
//   );
// };

// export default Databanner;



import React from "react";
import { motion } from "framer-motion";

const Databanner = () => {
  const bannerStyles = {
   // marginTop: "60px",
    width: "100%",
    height: "90vh",
    backgroundImage: "url('/image/data-analysis-skill.jpeg')",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "flex-start", // align left
    alignItems: "center", // vertical middle
    textAlign: "left",
    color: "white",
    position: "relative",
    overflow: "hidden",
    paddingLeft: "5%", // little left padding
  };

  const contentStyles = {
    maxWidth: "700px",
  };

  const headingStyles = {
    fontSize: "32px",
    margin: 0,
    lineHeight: 1.2,
    fontWeight: "bold",
    letterSpacing: "0px",
    color:"white",
  };

  const paragraphStyles = {
    fontSize: "18px",
    marginTop: "1rem",
    lineHeight: 1.5,
    letterSpacing: "0px",
    textAlign:"justify",
  };

  return (
    <div style={bannerStyles}>
      <motion.div
        style={contentStyles}
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <h1 style={headingStyles}>Data Engineering</h1>
        <p style={paragraphStyles}>
          Data Engineering forms the backbone of modern analytics. It involves
          building reliable pipelines that transform raw data into structured,
          usable formats for advanced analytics and AI applications.
        </p>
        
      </motion.div>
    </div>
  );
};

export default Databanner;
